// extracted by mini-css-extract-plugin
module.exports = {"label":"ProjectCustomerInfoTab_label__3zG51","value":"ProjectCustomerInfoTab_value__2uOUf"};